import React from "react";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

function NavbarSeller({ handleDrawerToggle }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (!isMobile) {
    return null;
  }

  return (
    <IconButton
      aria-label="Open navigation menu"
      onClick={handleDrawerToggle}
      sx={{
        position: "fixed",
        top: { xs: 72, sm: 80 },
        left: 12,
        zIndex: 1200,
        bgcolor: "#151821",
        color: "#fff",
        border: "1px solid rgba(255, 255, 255, 0.08)",
        boxShadow: "0 4px 14px rgba(0, 0, 0, 0.18)",
        "&:hover": {
          bgcolor: "#1f2430",
        },
      }}
    >
      <MenuIcon />
    </IconButton>
  );
}

export default NavbarSeller;
